import { mediaViewerClicksConfig } from '@/lib/analytics/kpis/pinterest/mediaViewer/mediaViewerClicks';
import { mediaViewerCommentsConfig } from '@/lib/analytics/kpis/pinterest/mediaViewer/mediaViewerComments';
import { mediaViewerEngagementOnImpressionsConfig } from '@/lib/analytics/kpis/pinterest/mediaViewer/mediaViewerEngagementOnImpressions';
import { mediaViewerEngagementRateConfig } from '@/lib/analytics/kpis/pinterest/mediaViewer/mediaViewerEngagementRate';
import { mediaViewerEngagementsConfig } from '@/lib/analytics/kpis/pinterest/mediaViewer/mediaViewerEngagements';
import { mediaViewerImpressionRateConfig } from '@/lib/analytics/kpis/pinterest/mediaViewer/mediaViewerImpressionRate';
import { mediaViewerImpressionsConfig } from '@/lib/analytics/kpis/pinterest/mediaViewer/mediaViewerImpressions';
import { mediaViewerOutboundClickRateConfig } from '@/lib/analytics/kpis/pinterest/mediaViewer/mediaViewerOutboundClickRate';
import { mediaViewerOutboundClicksConfig } from '@/lib/analytics/kpis/pinterest/mediaViewer/mediaViewerOutboundClicks';
import { mediaViewerReactionsConfig } from '@/lib/analytics/kpis/pinterest/mediaViewer/mediaViewerReactions';
import { mediaViewerSavesConfig } from '@/lib/analytics/kpis/pinterest/mediaViewer/mediaViewerSaves';
import { mediaViewerVideoViewsConfig } from '@/lib/analytics/kpis/pinterest/mediaViewer/mediaViewerVideoViews';
import { mediaViewerVideoViews10SecConfig } from '@/lib/analytics/kpis/pinterest/mediaViewer/mediaViewerVideoViews10Sec';
import { mediaViewerVideoViews95PercentConfig } from '@/lib/analytics/kpis/pinterest/mediaViewer/mediaViewerVideoViews95Percent';
import { SIZE_50 } from '@/lib/gridElements/size';
import { PI_POST_TYPES, POST } from '@/lib/posts/postTypes';

const COMMON_CONFIG = [
    mediaViewerReactionsConfig,
    mediaViewerCommentsConfig,
    mediaViewerSavesConfig,
    mediaViewerClicksConfig,
    mediaViewerOutboundClicksConfig,
    mediaViewerOutboundClickRateConfig,
    mediaViewerEngagementRateConfig
];

const DEFAULT_CONFIG = [
    mediaViewerEngagementsConfig,
    ...COMMON_CONFIG,
    mediaViewerImpressionRateConfig,
    mediaViewerImpressionsConfig,
    mediaViewerEngagementOnImpressionsConfig
];

const VIDEO_CONFIG = [
    { ...mediaViewerEngagementsConfig, size: SIZE_50 },
    mediaViewerVideoViewsConfig,
    mediaViewerVideoViews10SecConfig,
    mediaViewerVideoViews95PercentConfig,
    ...COMMON_CONFIG
];

export const MediaViewerStatsPinterest = {
    [POST]: {
        [PI_POST_TYPES.TYPE_IMAGE]: DEFAULT_CONFIG,
        [PI_POST_TYPES.TYPE_MULTIPLE_IMAGES]: DEFAULT_CONFIG,
        [PI_POST_TYPES.TYPE_MULTIPLE_MIXED]: DEFAULT_CONFIG,
        [PI_POST_TYPES.TYPE_MULTIPLE_VIDEOS]: DEFAULT_CONFIG,
        [PI_POST_TYPES.TYPE_VIDEO]: VIDEO_CONFIG
    }
};
